import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { OverlayPanel } from "primeng/overlaypanel";
import { ReleaseNote } from "#models/release-note.model";
import { ReleaseNoteService } from "#services/api/release-note.service";
import { AuthService } from "#services/shared";

@Component({
  selector: "app-release-notes-dropdown",
  templateUrl: "./release-notes-dropdown.component.html",
  styleUrls: ["./release-notes-dropdown.component.scss"],
  standalone: false,
})
export class ReleaseNotesDropdownComponent implements OnInit {
  latestReleaseNotes: ReleaseNote[] = [];
  isLoading = false;
  hasError = false;
  fileNotFound = false;
  private currentUserId: number | null = null;

  constructor(
    private readonly _releaseNoteService: ReleaseNoteService,
    private readonly _router: Router,
    private readonly _authService: AuthService
  ) {}

  ngOnInit(): void {
    const currentUser = this._authService.getCurrentUser();
    this.currentUserId = currentUser?.ID || null;
    this.loadLatest();
  }

  get unreadCount(): number {
    return this.latestReleaseNotes.filter((item) => item.isUnread).length;
  }

  get unreadReleaseNotes(): ReleaseNote[] {
    return this.latestReleaseNotes.filter((item) => item.isUnread);
  }

  toggle(panel: OverlayPanel, event: Event): void {
    panel.toggle(event);
    if (!this.latestReleaseNotes.length && !this.isLoading) {
      this.loadLatest();
    }
  }

  viewAll(panel: OverlayPanel): void {
    this._releaseNoteService.markAsRead(
      this.latestReleaseNotes.filter((item) => item.isUnread).map((item) => item.id)
    );

    this.latestReleaseNotes = this.latestReleaseNotes.map((item) => ({
      ...item,
      isUnread: false,
    }));

    panel.hide();
    this._router.navigate(["/release-notes"]);
  }

  trackById(_index: number, item: ReleaseNote): string {
    return item.id;
  }

  getDisplayTitle(title: string): string {
    return String(title || "").replace(/\.pdf$/i, "");
  }

  private loadLatest(): void {
    this.isLoading = true;
    this.hasError = false;
    this.fileNotFound = false;

    this._releaseNoteService.getLatest(5, this.currentUserId || undefined).subscribe({
      next: (items) => {
        this.latestReleaseNotes = items;
        this.isLoading = false;
      },
      error: () => {
        this.hasError = true;
        this.isLoading = false;
      },
    });
  }
}
